import { getStoreId } from "$/hooks/use-store-information"
import partQueries from "$/lib/queries/part-queries"
import serviceSettingsQueries from "$/lib/queries/service-settings-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/price-list")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(partQueries.list({ storeId }))
      queryClient.prefetchQuery(serviceSettingsQueries.detail(storeId))
    }
    return {
      crumbs: "alfred.settings.nav.priceList.label",
    }
  },
})
